export const experience = [
  {
    logo: "/assets/images/Logos/SBAC.png",
    title: "Assistant Officer",
    company: "SBAC Bank PLC",
    type: "Full-time",
    period: "Jul 2024 – Present",
    location: "Dhaka, Bangladesh · On-site",
    accent: "cyan",
    bullets: [
      "Supported IT security and operations across 120 branches and approximately 1,500 endpoints",
      "Administered Wazuh/Elastic SIEM and FortiAnalyzer for log review, threat detection, and visibility",
      "Configured and maintained FortiGate 400E/1000E firewalls, VPNs, policies, segmentation, and SSL inspection",
      "Managed Kaspersky Endpoint Security server and enforced patch and antivirus compliance",
      "Oversaw Active Directory user lifecycle, group transfers, and Group Policy management",
      "Built automation scripts in PowerShell and Python to reduce onboarding and audit effort",
      "Supported branch-level IT including routers, switches, VLANs, VPNs, CCTV, and attendance systems",
      "Conducted IT audits per Bangladesh Bank guidelines and migrated PCs to the bank domain",
      "Developed internal dashboards and inventory apps using Flask and React",
    ],
    stack: ["Wazuh", "FortiAnalyzer", "FortiGate", "Kaspersky", "Active Directory"],
  },
  {
    logo: "/assets/images/Logos/SBAC.png",
    title: "Trainee Assistant Officer",
    company: "SBAC Bank PLC",
    type: "Full-time",
    period: "Jul 2023 – Jul 2024",
    location: "Dhaka, Bangladesh · On-site",
    accent: "blue",
    bullets: [
      "Supported security operations and vulnerability-related tasks",
      "Assisted with branch IT support and security administration workflows",
      "Built operational familiarity with banking infrastructure and compliance expectations",
    ],
    stack: ["Security Operations", "Vulnerability Support", "Branch IT"],
  },
  {
    logo: "/assets/images/Logos/SIGMIND.png",
    title: "Network Engineer",
    company: "SIGMIND.ai",
    type: "Contract",
    period: "Jan 2023 – Jul 2023",
    location: "Dhaka, Bangladesh · Hybrid",
    accent: "green",
    bullets: [
      "Configured LAN/WAN, ACLs, and routing for secure AI research infrastructure",
      "Conducted vulnerability assessments and applied mitigations",
      "Supported secure network operations in a hybrid environment",
    ],
    stack: ["LAN/WAN", "ACLs", "Routing", "Vulnerability Assessment"],
  },
  {
    logo: "/assets/images/Logos/CODECAMP.png",
    title: "Coding Teacher",
    company: "Code Camp",
    type: "Contract",
    period: "Oct 2022 – Dec 2022",
    location: "Melbourne, Victoria, Australia · On-site",
    accent: "amber",
    bullets: [
      "Ran summer programming camps teaching coding fundamentals to school students",
      "Delivered lessons in basic programming, problem-solving, and game development concepts",
      "Strengthened communication, leadership, and presentation skills through mentoring",
    ],
    stack: ["Teaching", "Communication", "Problem Solving"],
  },
  {
    logo: "/assets/images/Logos/TELSTRA.png",
    title: "Customer Service Representative",
    company: "Telstra",
    type: "Full-time",
    period: "Jul 2022 – Sep 2022",
    location: "Melbourne, Victoria, Australia",
    accent: "violet",
    bullets: [
      "Worked in the Credit Management Team and Financial Assistance and Support Team",
      "Assisted customers facing financial hardship with bill support and account changes",
      "Handled discounts, payment extensions, account holds, and service restrictions",
      "Used Telstra systems to update account details and troubleshoot related issues",
    ],
    stack: ["Salesforce", "Customer Support", "Case Handling"],
  },
  {
    logo: "/assets/images/Logos/SAFARA.png",
    title: "Junior Programmer / Software Developer",
    company: "Safara IT (Concern of Edison Foundation)",
    type: "Full-time",
    period: "Sep 2019 – Nov 2019",
    location: "Badda, Bangladesh",
    accent: "indigo",
    bullets: [
      "Started as a Laravel backend developer and later advanced into Vue.js frontend development",
      "Developed and maintained an ERP solution for Auko Tex Garments covering production, HR, accounts, and supply chain",
      "Acted as primary spokesperson for the software during client meetings, demos, and training sessions",
      "Visited client sites to provide end-user training and gathered requirements for new modules",
      "Enhanced ERP modules across both frontend and backend for scalability and usability",
    ],
    stack: ["Laravel", "Vue.js", "ERP", "Client Training"],
  },
  {
    logo: "/assets/images/Logos/SAFARA.png",
    title: "Software Engineer Intern",
    company: "Safara IT (Concern of Edison Foundation)",
    type: "Internship",
    period: "Feb 2019 – Aug 2019",
    location: "Baridhara, Bangladesh",
    accent: "slate",
    bullets: [
      "Supported full-scale web development tasks with senior guidance",
      "Contributed to feature development, debugging, and application improvements",
      "Built practical experience in production-style web workflows",
    ],
    stack: ["Web Development", "Debugging", "Feature Work"],
  },
];